import * as React from "react";
import { Button, Modal } from "components";

import { message, Progress } from "antd";

import "./bulk-select-modal.scss";
import { digitSperator } from "core/utils/decimalExtentions";
import { Enum, Order } from "../../../../../core/domain";
import { buttonType } from "../../../../../components/button/button";
import { OrderAction, OrderActionLabel } from "core/domain/order/order";
import { changeSingleOrderStatus, confirmAndPayoutSingleOrder } from "core/repositories/orders-transactions";

interface Props {
    selectedRows: Order[];
    selectedActionItem: Enum;
    setButtonLoading: any;
    buttonLoading: boolean;
    setSelectedRows: any;
    isOpen: boolean;
    setIsOpen: any;
    fetchData: () => void;
    actionItem: Enum;
    selectedTotalAmount?: number;
}

export const ConfirmBulkSelectModal: React.FC<Props> = ({
    selectedRows,
    selectedActionItem,
    buttonLoading,
    setButtonLoading,
    setSelectedRows,
    setIsOpen,
    isOpen,
    fetchData,
    actionItem,
    selectedTotalAmount,
}) => {
    const [completedTransactionsCount, setCompletedTransactionsCount] =
        React.useState<number>(0);
    const [isProccessSucceed, setIsProccessSucceed] = React.useState(true);

    React.useEffect(() => {
        completedTransactionsCount === selectedRows?.length &&
            onCompleteTransaction();
    }, [completedTransactionsCount]);

    async function onConfirmActionHandle() {
        if (selectedRows) {
            setIsProccessSucceed(true);
            for (const e of selectedRows) {
                try {
                    setButtonLoading(true);
                    actionItem.id === OrderAction.ConfirmAndPayout
                        ? await confirmAndPayoutSingleOrder(
                            setButtonLoading,
                            e,
                            () => setCompletedTransactionsCount((prev) => prev + 1),
                            (response) => {
                                console.log(response)
                            },
                        )
                        : await changeSingleOrderStatus(
                            setButtonLoading,
                            e,
                            selectedActionItem.id,
                            () => setCompletedTransactionsCount((prev) => prev + 1),
                            (response) => {
                                console.log(response)
                            },
                        );
                } catch {
                    setIsProccessSucceed(false);
                    setCompletedTransactionsCount((prev) => prev + 1);
                }
            }
        }
    }

    const closeActionModal = () => {
        setSelectedRows(undefined);
        setCompletedTransactionsCount(0);
        setIsProccessSucceed(true);
        setButtonLoading(false);
        setIsOpen(false);
        fetchData();
    };

    const onCompleteTransaction = async () => {
        setButtonLoading(false);
        if (isProccessSucceed) {
            message.success("همه تراکنش ها با موفقیت به روز شدند");
        } else {
            message.warning("برخی از تراکنش‌ها با خطا مواجه شدند. نتایج با موفقیت‌های انجام‌شده به‌روزرسانی شد");
        }
        fetchData();
        selectedRows && setCompletedTransactionsCount(selectedRows?.length);
        setCompletedTransactionsCount(0);
        setSelectedRows(undefined);
        setIsOpen(false);
    };

    return (
        <Modal
            setIsOpen={setIsOpen}
            isOpen={isOpen}
            className="transaction-action-approve-modal"
            onClose={closeActionModal}
        >
            <h3>{`از ${OrderActionLabel.get(selectedActionItem.id)} ${selectedRows.length
                }\u0020تراکنش انتخاب شده مطمئن هستید؟`}</h3>
            <div className="modal-content">
                {selectedTotalAmount && (
                    <p>
                        مجموع مقدار موارد انتخابی: {digitSperator(selectedTotalAmount)}{" "}
                        تومان
                    </p>
                )}
                <Progress
                    type="line"
                    percent={Math.round(
                        (completedTransactionsCount * 100) / selectedRows.length,
                    )}
                />
                <span>
                    {completedTransactionsCount} از {selectedRows.length} تراکنش انجام شده
                </span>
                {completedTransactionsCount > 0 && (
                    <span className={isProccessSucceed ? "status-ok" : "status-error"}>
                        {isProccessSucceed
                            ? "تا اینجا همه عملیات‌ها موفق بوده‌اند"
                            : "خطا در برخی تراکنش‌ها — پردازش ادامه دارد"}
                    </span>
                )}

                <div className="buttons">
                    <Button
                        type={buttonType.info}
                        text="بله مطمئنم"
                        loading={buttonLoading}
                        disabled={buttonLoading}
                        htmlType="button"
                        onClick={onConfirmActionHandle}
                    />
                    <Button
                        type={buttonType.outlined}
                        text="بازگشت"
                        onClick={closeActionModal}
                        disabled={buttonLoading}
                    />
                </div>
            </div>
        </Modal>
    );
};
